import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

import type { LabelDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const LABEL_FRAGMENT: TypedDocumentNode<LabelDTO> = gql`
  fragment labelFragment on AbTestsParametersLabel {
    label
  }
`
